import { Config } from 'common/config'

export const recapsUrl = ({
	trainingId,
	isTrainer,
}: {
	trainingId: string
	isTrainer: boolean
}): string =>
	isTrainer
		? `${Config.sessionPlanningHome}/trainer/trainings/${trainingId}/recaps`
		: `${Config.sessionPlanningHome}/trainings/${trainingId}/recaps`

export const navigateToRecaps = ({
	trainingId,
	isTrainer,
}: {
	trainingId: string
	isTrainer: boolean
}): void => {
	window.open(recapsUrl({ trainingId, isTrainer }), '_blank')
}
